import React, { useState, Fragment, useContext } from 'react';
import './Screens.scss';
import { AppContext } from "../../Context/AppContext";
// Material UI
import Box from "@mui/material/Box";
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
// Custom Plugins
import { customCloneDeep } from '../../Plugins/HelperFunctions';

const Screen2 = () => {
  const { screensData, setScreensData, setActiveScreen, setShowSnackbar, setSnackbarMessage, setActiveFocus } = useContext(AppContext);
  const [screen2, setScreen2] = useState(screensData.screen2);

  const handleChange = (e) => {
    let { name, value } = e.target;
    let errorName = `${name}Error`

    if (value === '' || value === undefined) {
      setScreen2({
        ...screen2,
        [name]: value,
        [errorName]: true
      });
    } else {
      setScreen2({
        ...screen2,
        [name]: value,
        [errorName]: false
      });
    }
  };

  const handleNext = () => {
    if (screen2.trim) {
      screen2.trimError = false;

      let clonedScreensData = customCloneDeep(screensData);
      clonedScreensData.screen2 = screen2;
      setScreensData(clonedScreensData);

      setActiveScreen((prevactiveScreen) => prevactiveScreen + 1);

    } else {
      screen2.trimError = true;
      setShowSnackbar(true);
      setSnackbarMessage('All required fields are not filled');
    }
  }

  const handlePrevious = () => {
    setActiveScreen((prevactiveScreen) => prevactiveScreen - 1);
  }


  return (
    <Fragment>
      <div className="screen">
        <form>
          <Box className="screen__wrapper" >
            <FormControl fullWidth error={screen2.trimError}>
              <InputLabel id="year-select-label">Trim</InputLabel>
              <Select
                labelId="trim-select-label"
                label="Trim"
                name="trim"
                value={screen2.trim}
                onFocus={() => setActiveFocus('trim')}
                onChange={handleChange}
              >
                <MenuItem value={10}>Trim</MenuItem>
                <MenuItem value={20}>Is</MenuItem>
                <MenuItem value={30}>Hidden</MenuItem>
              </Select>
              {screen2.trimError && <FormHelperText>Required</FormHelperText>}
            </FormControl>
          </Box>
        </form>
      </div>

      <Box className="screenBtnContainer" sx={{ pt: 4 }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={handlePrevious}
        >
          Previous
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleNext}
        >
          Next
        </Button>
      </Box>
    </Fragment>
  );
};

export default Screen2;
